type QueueItem = {
  resolve: (token: string) => void
  reject: (err: Error) => void
}

let isRefreshing = false
let queue: QueueItem[] = []

function flushQueue(token: string): void {
  queue.forEach(({ resolve }) => resolve(token))
  queue = []
}

function rejectQueue(err: Error): void {
  queue.forEach(({ reject }) => reject(err))
  queue = []
}

// Module-level singleton lock shared by the fetch interceptor and the proactive
// refresh poller in AuthProvider. Ensures only one refresh call is in-flight at
// a time; concurrent callers queue behind the active one.
export async function acquireRefreshLock(
  doRefresh: () => Promise<string>,
): Promise<string> {
  if (isRefreshing) {
    return new Promise<string>((resolve, reject) => {
      queue.push({ resolve, reject })
    })
  }

  isRefreshing = true

  try {
    const token = await doRefresh()
    flushQueue(token)
    return token
  } catch (err) {
    const error = err instanceof Error ? err : new Error('Refresh failed')
    rejectQueue(error)
    throw error
  } finally {
    isRefreshing = false
  }
}

export function resetRefreshLock(): void {
  rejectQueue(new Error('Auth cleanup'))
  isRefreshing = false
}
